
import { defineComponent } from 'vue'

import IconLogo02 from '@/components/icons/IconLogo02.vue'

export default defineComponent({
  components: { IconLogo02 },
})
